module.exports = __webpack_public_path__ + "img/huanbao.b80ef64e.png";